import {
  TeamPermissionItem,
  TeamPermissionMatrix,
} from "../services/permissionService";

export function getPermissionsForRole(
  matrix: TeamPermissionMatrix,
  roleName: string
): TeamPermissionItem[] {
  const permissions: TeamPermissionItem[] = [];

  matrix.groups.forEach((group) => {
    group.permissions.forEach((permission) => {
      if (permission.granted_roles.includes(roleName)) {
        permissions.push(permission);
      }
    });
  });

  return permissions;
}

export function isOwnerOnlyPermission(permission: TeamPermissionItem): boolean {
  return (
    permission.granted_roles.length === 1 && permission.granted_roles[0] === "owner"
  );
}

export function permissionTooltipKey(permissionName: string): string {
  return permissionName.replace(/:/g, "_");
}

export function matrixHasPermissions(matrix: TeamPermissionMatrix | null): boolean {
  if (!matrix) {
    return false;
  }

  return matrix.groups.some((group) => group.permissions.length > 0);
}
